

<div
	[formGroup]="totpForm"
	style="display: flex; flex-flow: row nowrap; padding: 1em 0; justify-content: space-around; max-width: 25em;"
>
	<div class="group3">
		<input matInput
			#inputTotp1
			class="inputTotpChar"
			type="tel"
			spellcheck="false"
			autocomplete="off"
			inputmode="numeric"
			pattern="[0-9]*"
			placeholder="1"
			[formControl]="codeCtrl1"
			(focus)="codeCtrl1.setValue('')"
		>
		<input matInput
			#inputTotp2
			class="inputTotpChar"
			type="tel"
			spellcheck="false"
			autocomplete="off"
			inputmode="numeric"
			pattern="[0-9]*"
			placeholder="2"
			[formControl]="codeCtrl2"
			(focus)="codeCtrl2.setValue('')"
		>
		<input matInput
			#inputTotp3
			class="inputTotpChar"
			type="tel"
			spellcheck="false"
			autocomplete="off"
			inputmode="numeric"
			pattern="[0-9]*"
			placeholder="3"
			[formControl]="codeCtrl3"
			(focus)="codeCtrl3.setValue('')"
		>
	</div>
	<div class="group3">
		<input matInput
			#inputTotp4
			class="inputTotpChar"
			type="tel"
			spellcheck="false"
			autocomplete="off"
			inputmode="numeric"
			pattern="[0-9]*"
			placeholder="4"
			[formControl]="codeCtrl4"
			(focus)="codeCtrl4.setValue('')"
		>
		<input matInput
			#inputTotp5
			class="inputTotpChar"
			type="tel"
			spellcheck="false"
			autocomplete="off"
			inputmode="numeric"
			pattern="[0-9]*"
			placeholder="5"
			[formControl]="codeCtrl5"
			(focus)="codeCtrl5.setValue('')"
		>				
		<input matInput
			#inputTotp6
			class="inputTotpChar"
			type="tel"
			spellcheck="false"
			autocomplete="off"
			inputmode="numeric"
			pattern="[0-9]*"
			placeholder="6"
			[formControl]="codeCtrl6"
			(focus)="codeCtrl6.setValue('')"
		>
	</div>
</div>
